module.exports = __webpack_public_path__ + "img/electronic_film_empty.35495110.png";